export default __webpack_public_path__ + "static/website-ebe29f2e2513b95d7e24e5c7b721f058.svg";